import { MetaOfferContentsMetadata } from "../interfaces/shop-cart.interface";

export function mapMetaOfferContents(metaOfferContents: any[] | undefined): MetaOfferContentsMetadata[] {
  if (!metaOfferContents?.length) {
    return [];
  }

  return metaOfferContents.map((metaOfferContent) => ({
    productOfferId: metaOfferContent?.product_offer_id,
    title: metaOfferContent?.title,
    offerType: metaOfferContent?.offer_type,
    isbn10: metaOfferContent?.isbn10,
    isbn13: metaOfferContent?.isbn13,
    primary: metaOfferContent?.primary,
    duration: metaOfferContent?.duration_in_days,
  }));
}